import { InputTypeEnum } from "../../enums/inputTypeEnum";
import * as React from "react";
import { AllInputProps } from "../../../interfaces/props/AllInputProps";
import { Currency } from "../../inputs/currency";
import DateOnly from "../../inputs/dateOnly";
import YesNo from "../../inputs/YesNo";
import PictureHyperLink from "../../inputs/pictureHyperLink";
import { HyperLink } from "../../inputs/hyperLink";
import DateTime from "../../inputs/dateTime";
import Choice from "../../inputs/choice";
import CheckboxMultiColumn from "../../inputs/checkboxMultiColumn";
import PeoplePicker from "../../inputs/peoplePicker";
import Taxonomy from "../../inputs/taxonomy";
import { Number } from "../../inputs/number";
import { Percentage } from "../../inputs/percentage";
import Multiline from "../../inputs/multiLine";
import NormalTextInput from "../../inputs/normalTextInput";
import { DataSourceDropdown } from "../../inputs/datasourceDropdown";
import { DataSourceMultipleDropdown } from "../../inputs/datasourceMultipleDropdown";
import LookupMulti from "../../inputs/lookupMulti";
import { ValidatorFactory } from "./ValidatorFactory";
import { DatasourceTagPicker } from "../../inputs/datasourceTagPicker";
import { DatasourceTextTagPicker } from "../../inputs/datasourceTextTagPicker";

export class InputFactoryHelper {
  constructor(private props: AllInputProps) { }

  create = (inputType: InputTypeEnum) => {
    switch (inputType) {
      case InputTypeEnum.DateOnly:
        return (
          <DateOnly
            {...this.setMainProps(this.props)}
            inputValidator={ValidatorFactory.createDateValidation(this.props.validationProperties)}
          />
        );
      case InputTypeEnum.DateTime:
        return (
          <DateTime
            {...this.setMainProps(this.props)}
            inputValidator={ValidatorFactory.createDateValidation(this.props.validationProperties)}
          />
        );
      case InputTypeEnum.Currency:
        return (
          <Currency
            {...this.setMainProps(this.props)}
            inputValidator={ValidatorFactory.createCurrencyValidator(this.props.validationProperties)}
          />
        );
      case InputTypeEnum.YesNo:
        return (
          <YesNo {...this.setMainProps(this.props)} inputValidator={ValidatorFactory.createNoValidation(this.props.validationProperties)} />
        );
      case InputTypeEnum.hyperLink:
        return (
          <HyperLink
            {...this.setMainProps(this.props)}
            inputValidator={ValidatorFactory.createHyperLinkValidator(this.props.validationProperties)}
          />
        );
      case InputTypeEnum.picture:
        return (
          <PictureHyperLink
            {...this.setMainProps(this.props)}
            inputValidator={ValidatorFactory.createHyperLinkValidator(this.props.validationProperties)}
          />
        );
      case InputTypeEnum.choice:
        return (
          <Choice
            Choices={this.props.Choices}
            {...this.setMainProps(this.props)}
            inputValidator={ValidatorFactory.createTextValidator(this.props.validationProperties)}
          />
        );
      case InputTypeEnum.multiChoice:
        return (
          <CheckboxMultiColumn
            Choices={this.props.Choices}
            {...this.setMainProps(this.props)}
            inputValidator={ValidatorFactory.createCollectionValidator(this.props.validationProperties)}
          />
        );
      case InputTypeEnum.peoplePickerSingle:
        return (
          <PeoplePicker
            UserSelectionScope={"0"}
            {...this.setMainProps(this.props)}
            webUrl={this.props.webUrl}
            itemLimit={1}
            inputValidator={ValidatorFactory.createPickerValidation(this.props.validationProperties)}
          />
        );
      case InputTypeEnum.peoplePickerMultiple:
        return (
          <PeoplePicker
            UserSelectionScope={this.props.UserSelectionScope}
            {...this.setMainProps(this.props)}
            webUrl={this.props.webUrl}
            itemLimit={10}
            inputValidator={ValidatorFactory.createPickerValidation(this.props.validationProperties)}
          />
        );
      case InputTypeEnum.taxonomySingle:
        return (
          <Taxonomy
            {...this.setMainProps(this.props)}
            {...this.taxonomyProps(this.props)}
            itemLimit={1}
            inputValidator={ValidatorFactory.createTaxonomyValidation(this.props.validationProperties)}
          />
        );
      case InputTypeEnum.taxonomyDouble:
        return (
          <Taxonomy
            {...this.setMainProps(this.props)}
            {...this.taxonomyProps(this.props)}
            itemLimit={10}
            inputValidator={ValidatorFactory.createTaxonomyValidation(this.props.validationProperties)}
          />
        );
      case InputTypeEnum.Number:
        return (
          <Number
            {...this.setMainProps(this.props)}
            min={this.props.min}
            max={this.props.max}
            inputValidator={ValidatorFactory.createNumberValidator(this.props.validationProperties)}
            decimals={this.props.validationProperties?.decimals}
          />
        );
      case InputTypeEnum.Percentage:
        return (
          <Percentage
            {...this.setMainProps(this.props)}
            min={this.props.min}
            max={this.props.max}
            inputValidator={ValidatorFactory.createPercentageValidator(this.props.validationProperties)}
            decimals={this.props.validationProperties?.decimals}
          />
        );
      case InputTypeEnum.MultiLine:
        return (
          <Multiline
            {...this.setMainProps(this.props)}
            inputValidator={ValidatorFactory.createTextValidator(this.props.validationProperties)}
          />
        );
      case InputTypeEnum.datasourceText:
        return (       
          <DatasourceTextTagPicker
          {...this.setMainProps(this.props)}
          inputValidator={ValidatorFactory.createTextValidator(this.props.validationProperties)}
        />
        );
      case InputTypeEnum.datasourceDropdown:
        return (
          <DataSourceDropdown
            {...this.setMainProps(this.props)}
            inputValidator={ValidatorFactory.createTextValidator(this.props.validationProperties)}
          />
        );
      case InputTypeEnum.datasourceMultipleDropdown:
        return (
          <DataSourceMultipleDropdown
            {...this.setMainProps(this.props)}
            inputValidator={ValidatorFactory.createCollectionValidator(this.props.validationProperties)}
          />
        );
      case InputTypeEnum.lookupSingle:
        return (
          <LookupMulti
            itemLimit={1}
            {...this.setMainProps(this.props)}
            inputValidator={ValidatorFactory.createPickerValidation(this.props.validationProperties)}
          />
        );
      case InputTypeEnum.lookupMulti:
        return (
          <LookupMulti
            itemLimit={99}
            {...this.setMainProps(this.props)}
            inputValidator={ValidatorFactory.createPickerValidation(this.props.validationProperties)}
          />
        );
      case InputTypeEnum.Text:
        return (
          <NormalTextInput
            inputValidator={ValidatorFactory.createTextValidator(this.props.validationProperties)}
            {...this.setMainProps(this.props)}
          />
        );
      case InputTypeEnum.datasourceTagPicker:
        return (<DatasourceTagPicker
          {...this.setMainProps(this.props)}
          inputValidator={ValidatorFactory.createCollectionValidator(this.props.validationProperties)}
        />)
      default:
        return (
          <NormalTextInput
            inputValidator={ValidatorFactory.createTextValidator(this.props.validationProperties)}
            {...this.setMainProps(this.props)}
          />
        );
    }
  };

  private setMainProps = (props: AllInputProps) => {
    return {
      displayName: props.displayName,
      internalName: props.internalName,
      isRequired: props.isRequired,
      inputValue: props.inputValue,
      error: props.error,
      webUrl: props.webUrl,
      updateInputValidationStatus: props.updateInputValidationStatus,
      regionalSetting: props.regionalSetting,
      listId: props?.listId,
      columnInternalName: props?.columnInternalName,
      validationProperties: props.validationProperties,
    };
  };

  private taxonomyProps = (props: AllInputProps) => {
    return {
      sharepointService: props.sharepointService,
      //documentLibrary: props.documentLibrary,
      sharepointListId: props.sharepointListId
    };
  };
}
